var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackdrop4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 906,
    height: 586,
    viewBox: "0 0 906 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2244_34946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.5 255.91L255 315.149L327.638 330.669L650.5 255.91Z",
    fill: "#FCD535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2244_34946",
    x: 0,
    y: 0.909637,
    width: 905.5,
    height: 584.759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 127.5,
    result: "effect1_foregroundBlur_2244_34946"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdrop4);
export default __webpack_public_path__ + "static/media/backdrop4.ebaa43f31f0fb945ce300116184cc788.svg";
export { ForwardRef as ReactComponent };